function userReducer() {
  return {};
}

export default userReducer;
